exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zero-pending-tasks{background-color:#000;border-radius:20px;border:2px solid #000;padding:0 4px;text-align:center;width:fit-content}", ""]);

// exports
